import React from "react";
import { SideMenu, Model } from "./../../components";
import "./profile.css";
import ProfileHeaderImage from "./../../../assets/images/profileHeader.png";
import ProfileImage from "./../../../assets/images/profileImage.jpg";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { MdEdit, MdEmail, MdWifiCalling3 } from "react-icons/md";
import { BsPlusLg } from "react-icons/bs";
import EducationIcon from "./../../../assets/svg/educationIcon.svg";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Countries from "./../../../data/countries";
import Checkbox from "@mui/material/Checkbox";
import Months from "./../../../data/months";
import Years from "./../../../data/years";
import Relationship from "./../../../data/relationship";
import { IoCamera } from "react-icons/io5";
import { useAlert } from "react-alert";
const label = { inputProps: { "aria-label": "Checkbox demo" } };
const Input = styled("input")({
  display: "none",
});
let Profile = () => {
  const alert = useAlert();
  const [editContactInformation, setEditContactInformation] =
    React.useState(false);
  const [editOverview, setEditOverview] = React.useState(false);
  const [established, setEstablished] = React.useState(false);
  const [establishedModelType, setEstablishedModelType] = React.useState("");
  const [certificate, setCertificate] = React.useState(false);
  const [certificateModelType, setCertificateModelType] = React.useState("");
  const [addSkills, setAddSkills] = React.useState(false);
  const [branches, setBranches] = React.useState(false);
  const [branchesModelType, setBranchesModelType] = React.useState("");
  const [askRecommendations, setAskRecommendations] = React.useState(false);
  const [addRecommendations, setAddRecommendations] = React.useState(false);
  const [moreData, setMoreData] = React.useState(false);
  const [countryCode, setCountryCode] = React.useState("");
  const [selectedCountryCode, setSelectedCountryCode] = React.useState();
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
    Countries.map((v, i) => {
      if (Countries[i].alpha2Code === e.target.value) {
        setSelectedCountryCode(Countries[i].callingCode);
      }
    });
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];

  // Edit Contact Information
  const [contactFirstName, setContactFirstName] = React.useState("David");
  const [contactLastName, setContactLastName] = React.useState("Anderson");
  const [contactCourseTitle, setContactCourseTitle] = React.useState(
    "English,Mathematics, And Science Teachers"
  );
  const [contactEmail, setContactEmail] = React.useState("");
  const [contactMobileNumber, setContactMobileNumber] = React.useState("");
  const [contactLoading, setContactLoading] = React.useState(false);
  const contactFirstNameRef = React.useRef();
  const contactLastNameRef = React.useRef();
  const contactCourseTitleRef = React.useRef();
  const contactContryCodeRef = React.useRef();
  const contactEmailRef = React.useRef();
  const contactMobileNumberRef = React.useRef();
  const EditContactInformation = () => {
    if (contactFirstName === "") {
      alert.error(<div className="alert-message">first name required</div>);
      contactFirstNameRef.current.focus();
    } else if (contactLastName === "") {
      alert.error(<div className="alert-message">last name required</div>);
      contactLastNameRef.current.focus();
    } else if (contactCourseTitle === "") {
      alert.error(<div className="alert-message">course title required</div>);
      contactCourseTitleRef.current.focus();
    } else if (contactEmail === "") {
      alert.error(<div className="alert-message">email id required</div>);
      contactEmailRef.current.focus();
    } else if (countryCode === "") {
      alert.error(
        <div className="alert-message">please select country code</div>
      );
    } else if (contactMobileNumber === "") {
      alert.error(
        <div className="alert-message">please type valid mobile number</div>
      );
      contactMobileNumberRef.current.focus();
    } else {
      setContactLoading(true);
      let ContactInformation = {
        firstName: contactFirstName,
        lastName: contactLastName,
        courseTitle: contactCourseTitle,
        email: contactEmail,
        code: selectedCountryCode,
        mobNumber: contactMobileNumber,
      };
      console.log(ContactInformation);
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      setTimeout(() => {
        setEditContactInformation(false);
        setContactLoading(false);
      }, 2000);
    }
  };

  // Edit Overview
  const [overviewText, setOvereviewText] = React.useState("");
  const [overviewLoading, setOverviewLoading] = React.useState(false);
  const overviewTextRef = React.useRef();
  const OverviewEditHandler = () => {
    if (overviewText === "") {
      alert.error(<div className="alert-message">please add description</div>);
      overviewTextRef.current.focus();
    } else {
      setOverviewLoading(true);
      const Overview = {
        description: overviewText,
      };
      console.log(Overview);
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      setTimeout(() => {
        setEditOverview(false);
        setOverviewLoading(false);
      }, 2000);
    }
  };

  // Established Add and Edit
  const [establishedTitle, setEstablishedTitle] = React.useState("");
  const [establishedEmploymentType, setEstablishedEmploymentType] =
    React.useState("");
  const [establishedCompanyName, setEstablishedCompanyName] =
    React.useState("");
  const [establishedLocation, setEstablishedLocation] = React.useState("");
  const [establishedCurrentlyWorking, setEstablishedCurrentlyWorking] =
    React.useState(false);
  const [establishedStartMonth, setEstablishedStartMonth] = React.useState("");
  const [establishedStartYear, setEstablishedStartYeare] = React.useState("");
  const [establishedEndMonth, setEstablishedEndMonth] = React.useState("");
  const [establishedEndYear, setEstablishedEndYeare] = React.useState("");
  const [establishedLoading, setEstablishedLoading] = React.useState("");
  const establishedTitleRef = React.useRef();
  const establishedEmploymentTypeRef = React.useRef();
  const establishedCompanyNameRef = React.useRef();
  const establishedLocationRef = React.useRef();
  const establishedStartMonthRef = React.useRef();
  const establishedStartYearRef = React.useRef();
  const establishedEndMonthRef = React.useRef();
  const establishedEndYearRef = React.useRef();
  let EstablishedHandler = () => {
    if (establishedTitle === "") {
      alert.error(<div className="alert-message">please add title</div>);
      establishedTitleRef.current.focus();
    } else if (establishedEmploymentType === "") {
      alert.error(
        <div className="alert-message">please type Employment Type</div>
      );
      establishedEmploymentTypeRef.current.focus();
    } else if (establishedCompanyName === "") {
      alert.error(
        <div className="alert-message">please type Company name</div>
      );
      establishedCompanyNameRef.current.focus();
    } else if (establishedLocation === "") {
      alert.error(<div className="alert-message">please add location</div>);
      establishedLocationRef.current.focus();
    } else if (establishedStartMonth === "") {
      alert.error(
        <div className="alert-message">please select start month</div>
      );
      establishedStartMonthRef.current.focus();
    } else if (establishedStartYear === "") {
      alert.error(
        <div className="alert-message">please select start year</div>
      );
      establishedStartYearRef.current.focus();
    } else if (establishedEndMonth === "") {
      alert.error(<div className="alert-message">please select end month</div>);
      establishedEndMonthRef.current.focus();
    } else if (establishedEndYear == "") {
      alert.error(<div className="alert-message">please select end year</div>);
      establishedEndYearRef.current.focus();
    } else {
      setEstablishedLoading(true);
      const EstablishedObject = {
        title: establishedTitle,
        employmentType: establishedEmploymentType,
        companyName: establishedCompanyName,
        location: establishedLocation,
        currentlyWorking: establishedCurrentlyWorking,
        startMonth: establishedStartMonth,
        startYear: establishedStartYear,
        endMonth: establishedEndMonth,
        endYear: establishedEndYear,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(EstablishedObject);
      setTimeout(() => {
        setEstablished(false);
        setEstablishedLoading(false);
      }, 2000);
    }
  };

  // Certificate Add and Edit
  const [certificateTitle, setCertificateTitle] = React.useState("");
  const [certificateSubTitle, setCertificateSubTitle] = React.useState("");
  const [certificateCompanyName, setCertificateCompanyName] =
    React.useState("");
  const [certificateLocation, setCertificateLocation] = React.useState("");
  const [certificateMonth, setCertificateMonth] = React.useState("");
  const [certificateYear, setCertificateYear] = React.useState("");
  const [certificateLoading, setCertificateLoading] = React.useState(false);
  const certificateTitleRef = React.useRef();
  const certificateSubTitleRef = React.useRef();
  const certificateCompanyNameRef = React.useRef();
  const certificateLocationRef = React.useRef();
  const certificateMonthRef = React.useRef();
  const certificateYearRef = React.useRef();
  let CertificateHandler = () => {
    if (certificateTitle === "") {
      alert.error(<div className="alert-message">please add title</div>);
      certificateTitleRef.current.focus();
    } else if (certificateSubTitle === "") {
      alert.error(<div className="alert-message">please add sub title</div>);
      certificateSubTitleRef.current.focus();
    } else if (certificateCompanyName === "") {
      alert.error(
        <div className="alert-message">please type company name</div>
      );
      certificateCompanyNameRef.current.focus();
    } else if (certificateLocation === "") {
      alert.error(<div className="alert-message">please add location</div>);
      certificateLocationRef.current.focus();
    } else if (certificateMonth === "") {
      alert.error(<div className="alert-message">please select month</div>);
      certificateMonthRef.current.focus();
    } else if (certificateYear === "") {
      alert.error(<div className="alert-message">please select year</div>);
      certificateYearRef.current.focus();
    } else {
      setCertificateLoading(true);
      const CertificateObject = {
        title: certificateTitle,
        subTitle: certificateSubTitle,
        companyName: certificateCompanyName,
        location: certificateLocation,
        month: certificateMonth,
        year: certificateYear,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(CertificateObject);
      setTimeout(() => {
        setCertificate(false);
        setCertificateLoading(false);
      }, 2000);
    }
  };

  // Add New Skills
  const [skillTitle, setSkillTitle] = React.useState("");
  const [skillLoading, setSkillLoading] = React.useState("");
  const skillTitleRef = React.useRef();
  let AddNewSkillsHandler = () => {
    if (skillTitle === "") {
      alert.error(<div className="alert-message">please type skill</div>);
      skillTitleRef.current.focus();
    } else {
      setSkillLoading(true);
      const NewSkillsObject = {
        skill: skillTitle,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(NewSkillsObject);
      setTimeout(() => {
        setAddSkills(false);
        setSkillLoading(false);
      }, 2000);
    }
  };

  // Branches Add and Edit
  const [branchName, setBranchName] = React.useState("");
  const [branchDescription, setBranchDescription] = React.useState("");
  const [branchCountry, setBranchCountry] = React.useState("");
  const [branchState, setBranchState] = React.useState("");
  const [branchLocation, setBranchLocation] = React.useState("");
  const [branchLoading, sestBranchLoading] = React.useState(false);
  const branchNameRef = React.useRef();
  const branchDescriptionRef = React.useRef();
  const branchCountryRef = React.useRef();
  const branchStateRef = React.useRef();
  const branchLocationRef = React.useRef();
  const BranchesHandler = () => {
    if (branchName === "") {
      alert.error(<div className="alert-message">please add branch name</div>);
      branchNameRef.current.focus();
    } else if (branchDescription === "") {
      alert.error(
        <div className="alert-message">please type branch description</div>
      );
      branchDescriptionRef.current.focus();
    } else if (branchCountry === "") {
      alert.error(<div className="alert-message">please select country</div>);
      branchCountryRef.current.focus();
    } else if (branchState === "") {
      alert.error(<div className="alert-message">please select state</div>);
      branchStateRef.current.focus();
    } else if (branchLocation === "") {
      alert.error(<div className="alert-message">please add location</div>);
      branchLocationRef.current.focus();
    } else {
      sestBranchLoading(true);
      const BranchObject = {
        name: branchName,
        description: branchDescription,
        country: branchCountry,
        state: branchState,
        location: branchLocation,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(BranchObject);
      setTimeout(() => {
        setBranches(false);
        sestBranchLoading(false);
      }, 2000);
    }
  };

  // Ask Recommendations
  const [askRecommendationsFirstName, setAskRecommendationsFirstName] =
    React.useState("");
  const [askRecommendationsLastName, setAskRecommendationsLastName] =
    React.useState("");
  const [askRecommendationsEmail, setAskRecommendationsEmail] =
    React.useState("");
  const [askRecommendationsAsk, setAskRecommendationsAsk] = React.useState("");
  const [askRecommendationsKnow, setAskRecommendationsKnow] =
    React.useState("");
  const [askRecommendationsPosition, setAskRecommendationsPosition] =
    React.useState("");
  const [askRecommendationsMessage, setAskRecommendationsMessage] =
    React.useState("");
  const [askRecommendationsLoading, setAskRecommendationsLoading] =
    React.useState(false);
  const askRecommendationsFirstNameRef = React.useRef();
  const askRecommendationsLastNameRef = React.useRef();
  const askRecommendationsEmailRef = React.useRef();
  const askRecommendationsAskRef = React.useRef();
  const askRecommendationsKnowRef = React.useRef();
  const askRecommendationsPositionRef = React.useRef();
  const askRecommendationsMessageRef = React.useRef();
  const AskRecommendationsHandler = () => {
    if (askRecommendationsFirstName === "") {
      alert.error(<div className="alert-message">please type first name</div>);
      askRecommendationsFirstNameRef.current.focus();
    } else if (askRecommendationsLastName === "") {
      alert.error(<div className="alert-message">please type last name</div>);
      askRecommendationsLastNameRef.current.focus();
    } else if (askRecommendationsEmail === "") {
      alert.error(
        <div className="alert-message">please type valid email address</div>
      );
      askRecommendationsEmailRef.current.focus();
    } else if (askRecommendationsAsk === "") {
      alert.error(
        <div className="alert-message">please type what Want To Ask</div>
      );
      askRecommendationsAskRef.current.focus();
    } else if (askRecommendationsKnow === "") {
      alert.error(
        <div className="alert-message">please type How Do You Know </div>
      );
      askRecommendationsKnowRef.current.focus();
    } else if (askRecommendationsPosition === "") {
      alert.error(<div className="alert-message">please select position</div>);
      askRecommendationsPositionRef.current.focus();
    } else if (askRecommendationsMessage === "") {
      alert.error(<div className="alert-message">please type message</div>);
      askRecommendationsMessageRef.current.focus();
    } else {
      setAskRecommendationsLoading(true);
      const AskRecommendationsObject = {
        firstName: askRecommendationsFirstName,
        lastName: askRecommendationsLastName,
        email: askRecommendationsEmail,
        ask: askRecommendationsAsk,
        know: askRecommendationsKnow,
        position: askRecommendationsPosition,
        message: askRecommendationsMessage,
      };
      alert.success(
        <div className="alert-message">you have successfully saved</div>
      );
      console.log(AskRecommendationsObject);
      setTimeout(() => {
        setAskRecommendations(false);
        setAskRecommendationsLoading(false);
      }, 2000);
    }
  };

  // Resend Recommendations
  const [resendRecommendationsAsk, setResendRecommendationsAsk] =
    React.useState("");
  const [resendRecommendationsKnow, setResendRecommendationsKnow] =
    React.useState("");
  const [resendRecommendationsPosition, setResendRecommendationsPosition] =
    React.useState("");
  const [resendRecommendationsMessage, setResendRecommendationsMessage] =
    React.useState("");
  const [resendRecommendationsLoading, setResendRecommendationsLoading] =
    React.useState(false);
  const resendRecommendationsAskRef = React.useRef();
  const resendRecommendationsKnowRef = React.useRef();
  const resendRecommendationsPositionRef = React.useRef();
  const resendRecommendationsMessageRef = React.useRef();
  const ResendRecommendationsHandler = () => {
    if (resendRecommendationsAsk === "") {
      alert.error(
        <div className="alert-message">please type Who Do You Want To Ask</div>
      );
      resendRecommendationsAskRef.current.focus();
    } else if (resendRecommendationsKnow === "") {
      alert.error(
        <div className="alert-message">please type How Do You Know </div>
      );
      resendRecommendationsKnowRef.current.focus();
    } else if (resendRecommendationsPosition === "") {
      alert.error(<div className="alert-message">please select Position </div>);
      resendRecommendationsPositionRef.current.focus();
    } else if (resendRecommendationsMessage === "") {
      alert.error(<div className="alert-message">please type message </div>);
      resendRecommendationsMessageRef.current.focus();
    } else {
      setResendRecommendationsLoading(true);
      const ResendRecommendationsObject = {
        ask: resendRecommendationsAsk,
        know: resendRecommendationsKnow,
        position: resendRecommendationsPosition,
        message: resendRecommendationsMessage,
      };
      alert.success(
        <div className="alert-message">you have successfully re-send</div>
      );
      console.log(ResendRecommendationsObject);
      setTimeout(() => {
        setAddRecommendations(false);
        setResendRecommendationsLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu>
      <div>
        <img src={ProfileHeaderImage} className="header-cover-image" />
        <div className="profile-header-cover-edit-main">
          <label htmlFor="icon-button-file">
            <Input accept="image/*" id="icon-button-file" type="file" />
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              className="profile-upload-button"
            >
              <IoCamera
                color="#663399 "
                className="profile-upload-button-icon"
              />
            </IconButton>
          </label>
        </div>
      </div>

      <div className="profile-image-main">
        <img src={ProfileImage} className="profile-image" />
        <dvi className="profile-image-edit-main">
          <label htmlFor="icon-button-file">
            <Input accept="image/*" id="icon-button-file" type="file" />
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              className="profile-upload-button"
            >
              <IoCamera
                color="#663399 "
                className="profile-upload-button-icon"
              />
            </IconButton>
          </label>
        </dvi>
      </div>
      <div className="profile-user-edit-button-main">
        <Button onClick={() => setEditContactInformation(true)}>
          <MdEdit color="#000000" size={25} />
        </Button>
      </div>
      <div className="user-personal-data-main">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <p className="user-name">
                {contactFirstName} {contactLastName}
              </p>
              <p className="user-subjects-list">{contactCourseTitle}</p>
              <p className="user-location">burnside, united state</p>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
              <p className="contact-information-heading">Contact Information</p>
              <div className="contact-information-list">
                <MdEmail color="#303030" size={20} />
                <p className="contact-information-list-title">
                  Support@amafclasses.com
                </p>
              </div>
              <div className="contact-information-list">
                <MdWifiCalling3 color="#303030" size={20} />
                <p className="contact-information-list-title">+971 1 2345678</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">Overview</p>
          <Button onClick={() => setEditOverview(true)}>
            <MdEdit color="#000000" size={25} />
          </Button>
        </div>
        <p className="everview-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
          congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
          turpis ac congue. Curabitur viverra nunc cursus est efficitur, sit
          amet ornare felis accumsan. Ut eget elementum sem. Sed et nibh
          pharetra, commodo neque at, porta odio. Lorem ipsum dolor sit amet.
        </p>
        {moreData && (
          <p className="everview-description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue. Curabitur viverra nunc cursus est efficitur, sit
            amet ornare felis accumsan. Ut eget elementum sem. Sed et nibh
            pharetra, commodo neque at, porta odio. Lorem ipsum dolor sit amet.
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue. Curabitur viverra nunc cursus est efficitur, sit
            amet ornare felis accumsan. Ut eget elementum sem. Sed et nibh
            pharetra, commodo neque at, porta odio. Lorem ipsum dolor sit amet.
          </p>
        )}
        <br />
        {!moreData && (
          <Button
            className="view-details-button"
            variant="text"
            onClick={() => setMoreData(true)}
          >
            See all details
          </Button>
        )}
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">established in which year</p>
          <Button
            onClick={() => {
              setEstablished(true);
              setEstablishedModelType("Add");
            }}
          >
            <BsPlusLg color="#545454" size={25} />
          </Button>
        </div>
        <div className="box-data-main">
          <div className="box-list-main">
            <img src={ProfileImage} className="box-list-image" />
            <div>
              <p className="box-list-heading">Gmits classes</p>
              <p className="box-list-title">Institute</p>
              <p className="box-list-date">jan 2018 - present 4 years</p>
              <p className="box-list-location">
                3501 California St, burnside, united state
              </p>
            </div>
          </div>
          <Button
            className="box-list-edit-button"
            onClick={() => {
              setEstablished(true);
              setEstablishedModelType("Edit");
            }}
          >
            <MdEdit color="#545454" size={25} />
          </Button>
        </div>
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">Certificate</p>
          <Button
            onClick={() => {
              setCertificate(true);
              setCertificateModelType("Add");
            }}
          >
            <BsPlusLg color="#545454" size={25} />
          </Button>
        </div>
        <div className="box-data-main">
          <div className="box-list-main">
            <div className="box-list-image">
              <img src={EducationIcon} />
            </div>
            <div>
              <p className="box-list-heading">Dubai University</p>
              <p className="box-list-title">
                Bachelor's degree, Information Technology
              </p>
              <p className="box-list-date">2013 - 2017</p>
            </div>
          </div>
          <Button
            className="box-list-edit-button"
            onClick={() => {
              setCertificate(true);
              setCertificateModelType("Edit");
            }}
          >
            <MdEdit color="#545454" size={25} />
          </Button>
        </div>
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">Skills</p>
          <div>
            <Button onClick={() => setAddSkills(true)}>
              <p className="add-button-text">Add new skills</p>
              <BsPlusLg color="#545454" size={20} />
            </Button>
          </div>
        </div>
        <div className="skills-main">
          <p className="skilles-title">English</p>
        </div>
        <div className="skills-main">
          <p className="skilles-title">Mathematics</p>
        </div>
        <div className="skills-main">
          <p className="skilles-title">Science</p>
        </div>
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">Branches</p>
          <Button
            onClick={() => {
              setBranches(true);
              setBranchesModelType("Add");
            }}
          >
            <BsPlusLg color="#545454" size={25} />
          </Button>
        </div>
        <div className="branches-list-main">
          <div className="box-list-main">
            <img src={ProfileImage} className="box-list-image" />
            <div>
              <p className="box-list-heading">Dubai Branch</p>
              <p className="branches-list-address">
                3501 California St, burnside, united state
              </p>
              <p className="branches-list-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
          </div>
          <Button
            className="box-list-edit-button"
            onClick={() => {
              setBranches(true);
              setBranchesModelType("Edit");
            }}
          >
            <MdEdit color="#545454" size={25} />
          </Button>
        </div>
        <div className="branches-list-main">
          <div className="box-list-main">
            <img src={ProfileImage} className="box-list-image" />
            <div>
              <p className="box-list-heading">Dubai Branch</p>
              <p className="branches-list-address">
                3501 California St, burnside, united state
              </p>
              <p className="branches-list-description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in
                lorem congue, euismod urna vitae, porttitor mi. Aliquam
                consectetur eu turpis ac congue.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="data-box">
        <div className="data-box-header">
          <p className="data-box-heading">Recommendations</p>
          <div className="recommendations-edit-main">
            <p
              className="recommendations-edit-title"
              onClick={() => setAskRecommendations(true)}
            >
              Ask for recommendation
            </p>
            <Button onClick={() => setAddRecommendations(true)}>
              <MdEdit color="#545454" size={25} />
            </Button>
          </div>
        </div>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImage} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">Yesterday</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
        <div className="box-rating-main">
          <div className="box-rating-header">
            <img src={ProfileImage} className="box-list-image" />

            <div className="box-rating-second-section">
              <div>
                <p className="box-rating-username">Johan smith</p>
                <p className="box-rating-time">5 Lectures, 45 min</p>
              </div>
              <div className="box-rating-show">
                <Stack spacing={1}>
                  <Rating
                    name="half-rating-read"
                    defaultValue={5}
                    precision={1}
                    readOnly
                  />
                </Stack>
                <p className="box-rating-day">Yesterday</p>
              </div>
            </div>
          </div>
          <p className="box-rating-message">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
            congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
            turpis ac congue.
          </p>
        </div>
      </div>

      {/* EDIT CONTACT INFORMATIION */}
      <Model
        modelTitle="Edit Contact Information"
        onClose={() => setEditContactInformation(false)}
        open={editContactInformation}
        buttonTitle="save"
        buttonHandler={EditContactInformation}
        loading={contactLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">First name</p>
                  <input
                    type="text"
                    name="firstName"
                    className="input"
                    placeholder="Name"
                    value={contactFirstName}
                    ref={contactFirstNameRef}
                    onChange={(e) => setContactFirstName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Last name</p>
                  <input
                    type="text"
                    name="lastName"
                    className="input"
                    placeholder="Name"
                    value={contactLastName}
                    ref={contactLastNameRef}
                    onChange={(e) => setContactLastName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Headline</p>
                  <input
                    type="text"
                    name="course"
                    className="input"
                    placeholder="Your course title"
                    value={contactCourseTitle}
                    ref={contactCourseTitleRef}
                    onChange={(e) => setContactCourseTitle(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email ID</p>
                  <input
                    type="email"
                    name="email"
                    className="input"
                    placeholder="Enter your address"
                    value={contactEmail}
                    ref={contactEmailRef}
                    onChange={(e) => setContactEmail(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Mobile Number</p>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select
                        className="country-code-picker-dropdown"
                        ref={contactContryCodeRef}
                        onChange={handleDropdownChange}
                      >
                        <option value="">Select</option>
                        {Countries.map((countriesValue, countriesIndex) => {
                          return (
                            <option
                              key={countriesIndex}
                              value={countriesValue.alpha2Code}
                            >
                              {`${countriesValue.callingCode}  ${countriesValue.name}`}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="country-flag-main">
                      {Countries.map(
                        (countriesFlagValue, countriesFlagIndex) => {
                          return (
                            <div key={countriesFlagIndex}>
                              {countriesFlagValue.alpha2Code ===
                                countryCode && (
                                <img
                                  src={countriesFlagValue.flag}
                                  className="country-flag"
                                />
                              )}
                            </div>
                          );
                        }
                      )}
                      <input
                        type="number"
                        name="mobileNumber"
                        className="mobile-number-input"
                        placeholder="Enter your mobile number"
                        value={contactMobileNumber}
                        ref={contactMobileNumberRef}
                        onChange={(e) => setContactMobileNumber(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* EIDT OVERVIEW */}
      <Model
        modelTitle="Edit Overview"
        onClose={() => setEditOverview(false)}
        open={editOverview}
        buttonTitle="save"
        buttonHandler={OverviewEditHandler}
        loading={overviewLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Overview</p>
                  <textarea
                    className="textarea"
                    placeholder="Write your overview..."
                    rows="20"
                    cols="40"
                    value={overviewText}
                    ref={overviewTextRef}
                    onChange={(e) => setOvereviewText(e.target.value)}
                  ></textarea>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* ESTABLISHED MODEL */}
      <Model
        modelTitle={`${establishedModelType} Established In Which Year`}
        onClose={() => setEstablished(false)}
        open={established}
        buttonTitle="save"
        buttonHandler={EstablishedHandler}
        loading={establishedLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Title</p>
                  <input
                    type="text"
                    name="title"
                    className="input"
                    placeholder="Title"
                    value={establishedTitle}
                    ref={establishedTitleRef}
                    onChange={(e) => setEstablishedTitle(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Employment Type</p>
                  <input
                    type="text"
                    name="employmentType"
                    className="input"
                    placeholder="Employment Type"
                    value={establishedEmploymentType}
                    ref={establishedEmploymentTypeRef}
                    onChange={(e) =>
                      setEstablishedEmploymentType(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Company name</p>
                  <input
                    type="text"
                    name="companyName"
                    className="input"
                    placeholder="Company name"
                    value={establishedCompanyName}
                    ref={establishedCompanyNameRef}
                    onChange={(e) => setEstablishedCompanyName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Location</p>
                  <input
                    type="text"
                    name="location"
                    className="input"
                    placeholder="Location"
                    value={establishedLocation}
                    ref={establishedLocationRef}
                    onChange={(e) => setEstablishedLocation(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <div className="check-box-main">
              <Checkbox
                {...label}
                checked={establishedCurrentlyWorking}
                onChange={() =>
                  setEstablishedCurrentlyWorking(!establishedCurrentlyWorking)
                }
                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
              />
              <span className="check-box-title">
                I am currently working in this role
              </span>
            </div>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Start Month</p>
                  <select
                    className="input"
                    ref={establishedStartMonthRef}
                    onChange={(e) => setEstablishedStartMonth(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Months.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.monthName}
                        >
                          {countriesValue.monthName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Start Year</p>
                  <select
                    className="input"
                    ref={establishedStartYearRef}
                    onChange={(e) => setEstablishedStartYeare(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Years.map((stateValue, stateIndex) => {
                      return (
                        <option key={stateIndex} value={stateValue.year}>
                          {stateValue.year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">End Month</p>
                  <select
                    className="input"
                    ref={establishedEndMonthRef}
                    onChange={(e) => setEstablishedEndMonth(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Months.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.monthName}
                        >
                          {countriesValue.monthName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">End Year</p>
                  <select
                    className="input"
                    ref={establishedEndYearRef}
                    onChange={(e) => setEstablishedEndYeare(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Years.map((stateValue, stateIndex) => {
                      return (
                        <option key={stateIndex} value={stateValue.year}>
                          {stateValue.year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* CERTIFICATE MODEL */}
      <Model
        modelTitle={`${certificateModelType} Certificate`}
        onClose={() => setCertificate(false)}
        open={certificate}
        buttonTitle="save"
        buttonHandler={CertificateHandler}
        loading={certificateLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Title</p>
                  <input
                    type="text"
                    name="title"
                    className="input"
                    placeholder="Title"
                    value={certificateTitle}
                    ref={certificateTitleRef}
                    onChange={(e) => setCertificateTitle(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Subtitle</p>
                  <input
                    type="text"
                    name="subTitle"
                    className="input"
                    placeholder="Subtitle"
                    value={certificateSubTitle}
                    ref={certificateSubTitleRef}
                    onChange={(e) => setCertificateSubTitle(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Company name</p>
                  <input
                    type="text"
                    name="companyName"
                    className="input"
                    placeholder="Company name"
                    value={certificateCompanyName}
                    ref={certificateCompanyNameRef}
                    onChange={(e) => setCertificateCompanyName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Location</p>
                  <input
                    type="text"
                    name="location"
                    className="input"
                    placeholder="Location"
                    value={certificateLocation}
                    ref={certificateLocationRef}
                    onChange={(e) => setCertificateLocation(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select month</p>
                  <select
                    className="input"
                    ref={certificateMonthRef}
                    onChange={(e) => setCertificateMonth(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Months.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.monthName}
                        >
                          {countriesValue.monthName}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Start Year</p>
                  <select
                    className="input"
                    ref={certificateYearRef}
                    onChange={(e) => setCertificateYear(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Years.map((stateValue, stateIndex) => {
                      return (
                        <option key={stateIndex} value={stateValue.year}>
                          {stateValue.year}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                  <p className="upload-file-requirements">
                    (Upload only png,jpg,pdf)
                  </p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
      {/* ADD NEW SKILLS */}
      <Model
        modelTitle="Add new skills"
        onClose={() => setAddSkills(false)}
        open={addSkills}
        buttonTitle="save"
        buttonHandler={AddNewSkillsHandler}
        loading={skillLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Skill</p>
                  <input
                    type="text"
                    className="input"
                    placeholder="Write your skill..."
                    value={skillTitle}
                    ref={skillTitleRef}
                    onChange={(e) => setSkillTitle(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* BRANCHES */}
      <Model
        modelTitle={`${branchesModelType} Branches`}
        onClose={() => setBranches(false)}
        open={branches}
        buttonTitle="save"
        buttonHandler={BranchesHandler}
        loading={branchLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                <div>
                  <label htmlFor="icon-button-file">
                    <Input accept="image/*" id="icon-button-file" type="file" />
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      className="icon-button-file"
                    >
                      <BsPlusLg color="#7C7C7C" size={30} />
                    </IconButton>
                  </label>
                </div>
              </Grid>
              <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
                <div>
                  <p className="upload-file-heading">
                    upload your promotion thumbnail here.
                  </p>
                  <div>
                    <span className="upload-file-heading">
                      important guidelines:
                    </span>
                    <span className="upload-file-supported-message">
                      1200 x 800 or 12:8 ratio.
                    </span>
                  </div>
                  <div>
                    <span className="upload-file-heading">
                      suported formate:
                    </span>
                    <span className="upload-file-supported-message">
                      .jpg, .jpeg, or .png
                    </span>
                  </div>
                  <Button className="upload-file-button" variant="text">
                    Upload Image
                  </Button>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Branch Name</p>
                  <input
                    type="text"
                    name="branchName"
                    className="input"
                    placeholder="Branch Name"
                    value={branchName}
                    ref={branchNameRef}
                    onChange={(e) => setBranchName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Discription</p>
                  <input
                    type="text"
                    name="description"
                    className="input"
                    placeholder="Discription"
                    value={branchDescription}
                    ref={branchDescriptionRef}
                    onChange={(e) => setBranchDescription(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Country</p>
                  <select
                    className="input"
                    ref={branchCountryRef}
                    onChange={(e) => setBranchCountry(e.target.value)}
                  >
                    <option value="">Select</option>
                    {Countries.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.name}
                        >
                          {countriesValue.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">State</p>
                  <select
                    className="input"
                    ref={branchStateRef}
                    onChange={(e) => setBranchState(e.target.value)}
                  >
                    <option value="">Select</option>
                    {State.map((stateValue, stateIndex) => {
                      return (
                        <option key={stateIndex} value={stateValue.title}>
                          {stateValue.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">location</p>
                  <input
                    type="text"
                    name="location"
                    className="input"
                    placeholder="location"
                    value={branchLocation}
                    ref={branchLocationRef}
                    onChange={(e) => setBranchLocation(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* ASK RECOMMENDATIONS */}
      <Model
        modelTitle="Ask Recommendations"
        onClose={() => setAskRecommendations(false)}
        open={askRecommendations}
        buttonTitle="save"
        buttonHandler={AskRecommendationsHandler}
        loading={askRecommendationsLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">First name</p>
                  <input
                    type="text"
                    name="firstName"
                    className="input"
                    placeholder="Name"
                    value={askRecommendationsFirstName}
                    ref={askRecommendationsFirstNameRef}
                    onChange={(e) =>
                      setAskRecommendationsFirstName(e.target.value)
                    }
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Last name</p>
                  <input
                    type="text"
                    name="lastName"
                    className="input"
                    placeholder="Name"
                    value={askRecommendationsLastName}
                    ref={askRecommendationsLastNameRef}
                    onChange={(e) =>
                      setAskRecommendationsLastName(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email Address</p>
                  <input
                    type="email"
                    name="email"
                    className="input"
                    placeholder="  Email Address"
                    value={askRecommendationsEmail}
                    ref={askRecommendationsEmailRef}
                    onChange={(e) => setAskRecommendationsEmail(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Who do you want to ask?*</p>
                  <input
                    type="text"
                    name="ask"
                    className="input"
                    placeholder="Who do you want to ask?"
                    value={askRecommendationsAsk}
                    ref={askRecommendationsAskRef}
                    onChange={(e) => setAskRecommendationsAsk(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">
                    How do you know SuRaj? (Relationship )*
                  </p>
                  <input
                    type="text"
                    name="know"
                    className="input"
                    placeholder="How do you know SuRaj? (Relationship )"
                    value={askRecommendationsKnow}
                    ref={askRecommendationsKnowRef}
                    onChange={(e) => setAskRecommendationsKnow(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Position at the time* </p>
                  <select
                    className="input"
                    ref={askRecommendationsPositionRef}
                    onChange={(e) =>
                      setAskRecommendationsPosition(e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {Relationship.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.title}
                        >
                          {countriesValue.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">personalized message*</p>
                  <input
                    type="text"
                    name="message"
                    className="input"
                    placeholder="personalized message"
                    value={askRecommendationsMessage}
                    ref={askRecommendationsMessageRef}
                    onChange={(e) =>
                      setAskRecommendationsMessage(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* RESEND RECOMMENDATIONS */}
      <Model
        modelTitle="Resend Recommendations"
        onClose={() => setAddRecommendations(false)}
        open={addRecommendations}
        buttonTitle="re-Send"
        buttonHandler={ResendRecommendationsHandler}
        loading={resendRecommendationsLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Who do you want to ask?*</p>
                  <input
                    type="text"
                    name="ask"
                    className="input"
                    placeholder="Who do you want to ask?"
                    value={resendRecommendationsAsk}
                    ref={resendRecommendationsAskRef}
                    onChange={(e) =>
                      setResendRecommendationsAsk(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">
                    How do you know SuRaj? (Relationship )*
                  </p>
                  <input
                    type="text"
                    name="know"
                    className="input"
                    placeholder="How do you know SuRaj? (Relationship )"
                    value={resendRecommendationsKnow}
                    ref={resendRecommendationsKnowRef}
                    onChange={(e) =>
                      setResendRecommendationsKnow(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Position at the time* </p>
                  <select
                    className="input"
                    ref={resendRecommendationsPositionRef}
                    onChange={(e) =>
                      setResendRecommendationsPosition(e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {Relationship.map((countriesValue, countriesIndex) => {
                      return (
                        <option
                          key={countriesIndex}
                          value={countriesValue.title}
                        >
                          {countriesValue.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">personalized message*</p>
                  <input
                    type="text"
                    name="message"
                    className="input"
                    placeholder="personalized message"
                    value={resendRecommendationsMessage}
                    ref={resendRecommendationsMessageRef}
                    onChange={(e) =>
                      setResendRecommendationsMessage(e.target.value)
                    }
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default Profile;
